import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useLoadImage } from 'hooks/useLoadImage';
import { logoError, isFunction } from 'utilities/global';

interface IProps {
  className?: string;
  src: string;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  dataTestId?: string;
  alt?: string;
}

const Image = ({ className, src, onError, dataTestId = '', alt = '' }: IProps) => {
  const imageRef = useRef() as React.MutableRefObject<HTMLImageElement>;
  const { isLoaded: isValidSrc } = useLoadImage(src);

  const imageProps = {
    className,
    src,
    onError: isFunction(onError) ? onError : logoError,
    ...(dataTestId && { 'data-testid': dataTestId }),
    ...(alt && { alt })
  };

  useEffect(() => {
    if (!imageRef?.current) return;

    const imgElement = imageRef.current;
    if (imgElement.style.display === 'none') {
      imgElement.style.display = 'unset';
    }
  }, [src]);

  if (!isValidSrc) return null;
  return <ImageElement loading="lazy" decoding="async" {...imageProps} ref={imageRef} />;
};

export default Image;

const ImageElement = styled.img``;
